export const COLORS = [
  ["blanc", "Non traité", "#ffffff", "#94a3b8"], ["vert", "RDV décroché", "#dcfce7", "#16a34a"], ["bleu", "Opportunité créée", "#dbeafe", "#2563eb"], ["jaune", "Rappel à prévoir", "#fef9c3", "#ca8a04"],
  ["rose", "Mis de côté (autre produit)", "#fce7f3", "#db2777"], ["rouge", "Pas intéressé", "#fee2e2", "#dc2626"],
];
export const STATUS = { en_cours: "En cours", plein: "Plein", cloture: "Clôturé", archive: "Archivé" };
export const errText = (e) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : "Une erreur est survenue."; };
export const frDateTime = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");

export const ColorBar = ({ counts, total }) => (
  <div className="ps-bar" title={COLORS.map(([k, l]) => `${l} : ${counts?.[k] || 0}`).join(" · ")}>
    {total > 0 && COLORS.map(([k, , , c]) => (counts?.[k] ? <span key={k} style={{ width: `${(100 * counts[k]) / total}%`, background: k === "blanc" ? "#e2e8f0" : c }} /> : null))}
  </div>
);

export const Multi = ({ options, value, onChange, testid, placeholder }) => (
  <div className="ps-multi" data-testid={testid}>
    {options.map((o) => {
      const [v, l] = Array.isArray(o) ? o : [o, o];
      const on = value.includes(v);
      return <button key={v} type="button" className={`ps-pill${on ? " on" : ""}`} onClick={() => onChange(on ? value.filter((x) => x !== v) : [...value, v])}>{l}</button>;
    })}
    {!options.length && <span className="pl-muted">{placeholder}</span>}
  </div>
);
